import React from "react";
import Navbar from "../components/Navbar";
import Register from "../components/registerPage/Register"

const Sign_up = () => {
    return (
        <div className="Sign_up">
            <Register />
        </div>
    );
};

export default Sign_up;